// extracted by mini-css-extract-plugin
module.exports = {"cell":"HeaderCell_cell__G7Tlz","title":"HeaderCell_title__msn-l","dayName":"HeaderCell_dayName__3IXA9","dayDate":"HeaderCell_dayDate__31shH"};